import { useSelector } from "react-redux";
import { MenuRoutesType } from "src/constants/modules";
import { getMenuItems } from "src/Modules/MainMenu/components/ModulesMenu/utils";
import { RootState } from "src/store";

export default function useInitialTab() {
  const backendMenuItems = useSelector((state: RootState) => state.client.menuItems);
  const selectedClientId = useSelector((state: RootState) => state.client.selectedClientId);
  const menuItems = getMenuItems(backendMenuItems).filter((item) => !item.isstatic);

  const selectedTab:MenuRoutesType=
    menuItems.find((item) => item.key === selectedClientId)?.route ?? menuItems[0]?.route;

  return { selectedTab, menuItems };
}
